export const ColumnWidth = {
  width: 150
} as const
